'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrowStyle = exports.arrowVariants = undefined;
var _themeUtilities = require('../theme-utilities');
var _themeUtilities2 = _interopRequireDefault(_themeUtilities);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var arrowVariants = exports.arrowVariants = {
  active: 'active',
  complete: 'complete'
};
var arrowStyle = exports.arrowStyle = function arrowStyle() {
  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  return _themeUtilities2.default.apply(undefined, ['ProgressBarArrow'].concat(styles));
};
var arrowTheme = function arrowTheme(baseTheme) {
  var _Object$assign;
  return Object.assign((_Object$assign = {}, _defineProperty(_Object$assign, arrowStyle('color'), baseTheme.colorGrey), _defineProperty(_Object$assign, arrowStyle('color', arrowVariants.complete), baseTheme.colorBlack), _defineProperty(_Object$assign, arrowStyle('color', arrowVariants.active), baseTheme.colorWhite), _defineProperty(_Object$assign, arrowStyle('textDecoration', 'hover'), 'underline'), _defineProperty(_Object$assign, arrowStyle('backgroundColor'), baseTheme.colorGreyLight), _defineProperty(_Object$assign, arrowStyle('backgroundColor', arrowVariants.active), baseTheme.colorBlack), _defineProperty(_Object$assign, arrowStyle('backgroundColor', arrowVariants.complete), baseTheme.colorSecondary), _defineProperty(_Object$assign, 'Page_backgroundColor', 'baseTheme.colorWhite'), _Object$assign), baseTheme);
};
exports.default = {
  arrowTheme: arrowTheme,
  arrowStyle: arrowStyle,
  arrowVariants: arrowVariants
};